import React, { useEffect, useState } from "react";
import ListingCard from "../components/ListingCard";
import { Gavel, Clock, TrendingUp } from "lucide-react";
import { auctionsAPI } from "../lib/api";

export default function Auctions() {
  const [auctions, setAuctions] = useState([]);

  useEffect(() => {
    auctionsAPI.list().then(setAuctions).catch(() => setAuctions([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#1d3d3a] to-[#2d5350] text-white p-8 md:p-12 mb-8">
        <div className="absolute -right-12 -top-12 w-48 h-48 rounded-full bg-[#e86a24]/40 blur-3xl"/>
        <div className="relative">
          <div className="inline-flex items-center gap-2 bg-[#e86a24] auction-live px-3 py-1 rounded-full text-xs font-bold mb-3">
            <Gavel className="w-3 h-3"/> ASTE LIVE · SAN MARINO
          </div>
          <h1 className="text-3xl md:text-5xl font-black">Vinci l'oggetto dei tuoi sogni</h1>
          <p className="mt-3 max-w-xl text-slate-300">Partecipa alle aste tra utenti della Repubblica. Offri, rilancia, vinci. Pagamento protetto tramite Stripe.</p>
          <div className="mt-6 grid grid-cols-3 gap-4 max-w-md">
            <Stat value={auctions.length} label="Aste live" icon={Gavel}/>
            <Stat value={"24h"} label="Tempo medio" icon={Clock}/>
            <Stat value={"+32%"} label="Risparmio medio" icon={TrendingUp}/>
          </div>
        </div>
      </div>

      <h2 className="text-2xl font-black text-[#1d3d3a] mb-4">Tutte le aste attive</h2>
      {auctions.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-xl border border-slate-200 text-slate-500">
          Nessuna asta attiva al momento
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {auctions.map(a => <ListingCard key={a.id} auction={a} />)}
        </div>
      )}
    </div>
  );
}

function Stat({ value, label, icon: Icon }) {
  return (
    <div className="bg-white/10 backdrop-blur rounded-xl p-3">
      <Icon className="w-4 h-4 mb-1 text-[#e86a24]"/>
      <div className="text-xl font-black">{value}</div>
      <div className="text-[10px] text-slate-300 uppercase tracking-wider">{label}</div>
    </div>
  );
}
